export default __webpack_public_path__ + "static/media/3885.c1243426.png";